import moment from 'moment'

const calculatePeriodLabel = {
    day: (date) => date.toISODateString('/'),
    month: (date) => date.format("MMM 'YY"),
    quarter: (date) => {
        var quarter = date.getFiscalQuarterNumber()
        var range = date.getFiscalQuarterRange()
        return `Q${quarter} ${range.start.format("'YY")} - ${range.end.format("'YY")}`
    },
    year: (date) => date.format('YYYY'),
    fiscalYear: (date) => {
        var range = date.getYearRange()
        return `${range.start.format('YYYY')} - ${range.end.format('YYYY')}`
    }
}

if (!Date.prototype.getFiscalQuarterNumber) {
    Date.prototype.getFiscalQuarterNumber = function () {
        var month = this.getMonth() + 1
        if (month >= 7 && month <= 9) {
            // Q1: July - September
            return 1
        } else if (month >= 10 && month <= 12) {
            // Q2: October - December
            return 2
        } else if (month >= 1 && month <= 3) {
            // Q3: January - March
            return 3
        } else if (month >= 4 && month <= 6) {
            // Q4: April - June
            return 4
        }
    }
}

if (!Date.prototype.getPeriodLabel) {
    Date.prototype.getPeriodLabel = function (period) {
        var generateLabel = calculatePeriodLabel[period]
        if (!generateLabel) {
            throw new Error('Invalid period')
        }
        return generateLabel(this)
    }
}

if (!Date.prototype.getDayRange) {
    Date.prototype.getDayRange = function () {
        return {
            start: this.getStartOfDay(),
            end: this.getEndOfDay()
        }
    }
}

if (!Date.prototype.getWeekRange) {
    Date.prototype.getWeekRange = function () {
        var currentDay = this.getDay()
        var end = this.addDays(6 - currentDay)
        return {
            start: end.addDays(-6).getStartOfDay(),
            end: end.getEndOfDay()
        }
    }
}

if (!Date.prototype.getWorkWeekRange) {
    Date.prototype.getWorkWeekRange = function () {
        var normalWeek = this.getWeekRange()
        return {
            start: normalWeek.start.addDays(1),
            end: normalWeek.end.addDays(1)
        }
    }
}

if (!Date.prototype.getMonthRange) {
    Date.prototype.getMonthRange = function () {
        return {
            start: this.getFirstDayOfMonth().getStartOfDay(),
            end: this.getLastDayOfMonth().getEndOfDay()
        }
    }
}

if (!Date.prototype.getYearRange) {
    Date.prototype.getYearRange = function () {
        var start = new Date(this.getFullYear(), 0, 1)
        var end = start.addYears(1).addMilliseconds(-1)
        return {
            start,
            end
        }
    }
}

if (!Date.prototype.getFiscalQuarterRange) {
    Date.prototype.getFiscalQuarterRange = function () {
        var quarterNumber = this.getFiscalQuarterNumber()

        switch (quarterNumber) {
            case 1:
                return {
                    start: new Date(this.getFullYear(), 6, 1),
                    end: new Date(this.getFullYear(), 9, 1).addMilliseconds(-1)
                }
            case 2:
                return {
                    start: new Date(this.getFullYear(), 9, 1),
                    end: new Date(this.getFullYear(), 12, 1).addMilliseconds(-1)
                }
            case 3:
                return {
                    start: new Date(this.getFullYear(), 0, 1),
                    end: new Date(this.getFullYear(), 3, 1).addMilliseconds(-1)
                }
            case 4:
                return {
                    start: new Date(this.getFullYear(), 3, 1),
                    end: new Date(this.getFullYear(), 6, 1).addMilliseconds(-1)
                }
        }
    }
}

if (!Date.prototype.getFiscalYearRange) {
    Date.prototype.getFiscalYearRange = function () {
        var start = new Date(this.getFullYear(), 6, 1)

        if (this.getMonth() < 6) {
            start = start.addYears(-1)
        }

        return {
            start,
            end: start.addYears(1).addMilliseconds(-1)
        }
    }
}
